import type { FolioItem } from '~/generated/graphql'
import { publicRuntimeConfig } from '~/utils'
export function inspectFolioItems(prefix: string, folioItems: FolioItem[]) {
  if (publicRuntimeConfig.logLevel !== 'TRACE') return
  console.log(
    prefix,
    folioItems.map((fi) => [fi.id, fi.order])
  )
}
